import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';

import type {
  GridGetterFunction,
  GridCountFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ReceiptSearch } from '../../components/Receipt/ReceiptsSearch';

export const ReceiptsView: React.FC = () => {
  const spd = useSpdCore();

  const getData: GridGetterFunction = useCallback(
    (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      spd.receipts.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.receipts],
  );

  const getCount: GridCountFunction = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.receipts.getAllCount(filterText, filterColumns),
    [spd.receipts],
  );

  return (
    <Card>
      <Card.Header>Paragony</Card.Header>
      <Card.Body>
        <ReceiptSearch
          getData={getData}
          getCount={getCount}
          showFilter={true}
          withFilterInColumns={true}
          withExamNumber={true}
        />
      </Card.Body>
    </Card>
  );
};
